"use client"

import { ScreenNames } from "config/routing"
import { selectActiveBmSubId, useAppSelector } from "services"
import useDashboardRoutes from "../useDashboardRoutes/useDashboardRoutes"
import useFeatureRoutes from "../useFeatureRoutes/useFeatureRoutes"
import useSalesRoutes from "../useSalesRoutes"

const brewMenuPreferencesRoute = `${ScreenNames.Settings}/${ScreenNames.Preferences}`
const brewMenuPricingRoute = `${ScreenNames.Settings}/${ScreenNames.Pricing}`
const displaysRoute = `${ScreenNames.Displays}`
const editDisplayRoute = `${ScreenNames.Displays}/${ScreenNames.EditDisplay}`
const editMenuRoute = `${ScreenNames.Menus}/${ScreenNames.EditMenu}`
const menusRoute = `${ScreenNames.Menus}`
interface IBMRoutes {
    staticRoutes: {
        [key: string]: string
    }
    currentBMDashboard: () => string
    bmDashboard: () => string
    bmRoot: () => string
    bmSales: () => string
    displays: () => string
    editDisplay: (displayID: string) => string
    editMenu: (menuID: string) => string
    menus: () => string
    preferences: () => string
    pricing: () => string
}

const useBMRoutes = (): IBMRoutes => {
    const activeBmSubId = useAppSelector(selectActiveBmSubId)

    const { bmDashboard } = useDashboardRoutes()
    const { brewMenuFeatureRoute } = useFeatureRoutes()
    const { bmSales } = useSalesRoutes()

    const bmRoot = brewMenuFeatureRoute
    const bmSubWrapper = (link) =>
        activeBmSubId ? `${brewMenuFeatureRoute()}/${link}` : brewMenuFeatureRoute()

    const editDisplay = (displayId) => bmSubWrapper(`${editDisplayRoute}/${displayId}`)

    const displays = () => bmSubWrapper(displaysRoute)
    const menus = () => bmSubWrapper(menusRoute)
    const editMenu = (menuId) => bmSubWrapper(`${editMenuRoute}/${menuId}`)
    const preferences = () => bmSubWrapper(brewMenuPreferencesRoute)
    const pricing = () => bmSubWrapper(brewMenuPricingRoute)

    return {
        bmDashboard,
        bmRoot,
        bmSales,
        currentBMDashboard: bmDashboard,
        displays,
        editDisplay,
        editMenu,
        menus,
        preferences,
        pricing,
        staticRoutes: {
            displaysStatic: displaysRoute,
            editDisplayStatic: editDisplayRoute,
            menusStatic: menusRoute,
            editMenuStatic: editMenuRoute,
            brewMenuPreferencesStatic: brewMenuPreferencesRoute,
            brewMenuPricingStatic: brewMenuPricingRoute
        }
    }
}

export default useBMRoutes
